import React from "react";
import { Carousel } from "react-bootstrap";
import './Carousel.css'
import "bootstrap/dist/css/bootstrap.min.css";
interface CaruselProps {
    style: any
}
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const BootstrapCarousel: React.FC <CaruselProps> = ({ style }) => {
    const logos = [
        "/assets/operators/airtel.png",
        "/assets/operators/at.png",
        "/assets/operators/celtiis.png",
        "/assets/operators/halo.png",
        "/assets/operators/mixx.png",
        "/assets/operators/momo.png",
        "/assets/operators/movitel.png",
        "/assets/operators/movo.png",
        "/assets/operators/mpesa.png",
        "/assets/operators/orangemoney.png",
        "/assets/operators/telecel.png",
        "/assets/operators/tnm.png",
        "/assets/operators/vodacom.png",
        "/assets/operators/wave.png",
        "/assets/operators/zamtel.png",
    ];

    const chunkSize = 4;
    const chunks = Array.from({ length: Math.ceil(logos.length / chunkSize) }, (_, i) =>
        logos.slice(i * chunkSize, i * chunkSize + chunkSize)
    );

    return (
        <div className="carousel-container mt-3"
        style={{
            backgroundColor: style.colors.blockTitleBgColor,
        }}
        >
            <Carousel controls={false} indicators={false} interval={3000} pause={false}>
                {chunks.map((group, index) => (
                    <Carousel.Item key={index}>
                        <div className="d-flex justify-content-center align-items-center">
                            {group.map((src, idx) => (
                                <img
                                    key={idx}
                                    src={`${toAbsoluteUrl(src)}`}
                                    alt={`Logo-${idx}`}
                                    className="carousel-logo mx-2"
                                    style={{
                                        border: `.5px solid ${style.colors.fontColor}`,
                                        borderRadius: '4px'
                                    }}
                                />
                            ))}
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

export default BootstrapCarousel;
